import React from "react"
import { css, cx } from "@emotion/css"
import { useToggle } from "hooks/useToggle"
import Nav from "./Nav"
import { useLocation } from "react-router-dom"

const NAV_BAR_WIDTH_EXP = 176
const NAV_BAR_WIDTH_COL = 48

const cns = {
  root: css`
    display: flex;
    height: 100vh;
    overflow: hidden;
  `,
  collapsed: css`
    min-width: ${NAV_BAR_WIDTH_COL}px;
    width: ${NAV_BAR_WIDTH_COL}px;
  `,
  nav: css`
    background-color: var(--primary-main);
    min-width: ${NAV_BAR_WIDTH_EXP}px;
  `,
  content: css`
    width: 100vw;
    overflow-y: auto;
  `,
  revenueContent: css`
    background-color: black;
    width: 100%;
    overflow-y: auto;
    overflow-x: auto;
    ::-webkit-scrollbar {
      width: 6px;
      border-radius: 4px;
      background: var(--primary-main-light-green);
    }
    ::-webkit-scrollbar-thumb {
      width: 6px;
      height: 24px;
      border-radius: 4px;
      background: var(--primary-main-light-green);
    }
    ::-webkit-scrollbar-track-piece {
      background: var(--extra-dark-grey);
    }
  `,
}

function Layout(props: { children: React.ReactNode }) {
  const { children } = props
  const { open, onToggle } = useToggle(true)
  const location = useLocation()
  const inRevenue = location.pathname === "/revenue"
  return (
    <div className={cns.root}>
      <aside className={cx(cns.nav, { [cns.collapsed]: open })}>
        <Nav isCollapsed={open} onToggle={onToggle} />
      </aside>
      <main className={!inRevenue ? cns.content : cns.revenueContent}>
        {children}
      </main>
    </div>
  )
}

export default Layout
